import { PageBase } from 'frontend/common-imports'

export default class RoomLeaderboardPage extends PageBase {
  static handleDOMReady () {
    const menuItems = document.querySelectorAll('.location_menu .location_menu_item')
    const formWraps = document.querySelectorAll('.select_room .all_lists')

    document.querySelectorAll('.select_room .all_lists select').forEach(select => {
      select.addEventListener('change', () => {
        window.location = select.value
      })
    })

    menuItems.forEach(menuItem => {
      menuItem.addEventListener('click', () => {
        menuItems.forEach(el => { el.classList.remove('is-active') })
        formWraps.forEach(el => { el.style.display = 'none' })
        menuItem.classList.add('is-active')

        const link = menuItem.querySelector('.location_name')
        document.querySelector(`#location_${link.dataset.location}`).style.display = 'block'
      })
    })
  }
}

RoomLeaderboardPage.init()
